import axios from "axios";

export async function getMaterials({ commit }, payload) {
  try {
    const { data } = await axios.get("/material/get", {
      params: payload,
    });
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function addMaterial({ commit }, payload) {
  try {
    const { data } = await axios.post("/material/add", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function updateMaterial({ commit }, payload) {
  try {
    const { data } = await axios.put("/material/update", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getValidationsByMaterial({ commit }, payload) {
  try {
    const { data } = await axios.get("/material/validations-by-material", {
      params: payload,
    });
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getValidation({ commit }, payload) {
  try {
    const { data } = await axios.get("/material/validation", {
      params: payload,
    });
    // Fetch  list.
    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function updateValidation({ commit }, payload) {
  try {
    const { data } = await axios.post("/material/updateValidation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function newValidation({ commit }, payload) {
  try {
    const { data } = await axios.post("/material/newValidation", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}
